import React from 'react';
import "./BookingNavbar.css";

import icon1 from "../../../assets/icons/NavIconRequestGrey.svg";
import icon2 from "../../../assets/icons/BookingsGrey.svg";
import coloredBookkings from "../../../assets/icons/BookingsColored.svg"
import coloredRequests from "../../../assets/icons/NavIconRequestsColored.svg"

export default function BookingNavbar({ navbarActive, setNavbarActive }) {
  // Click handlers to toggle between My Bookings and Requests
  const handleClickBookings = () => {
    setNavbarActive('myBookings');
  }

  const handleRequestsClick = () => {
    setNavbarActive('requests');
  }

  return (
    <div className='booking-navbar'>
      <div
        className={`booking-icon ${navbarActive === 'requests' ? 'active' : ''}`}
        onClick={handleRequestsClick}
      >
        {navbarActive === 'requests' ? <img src={coloredRequests} alt="" /> : <img src={icon1} alt="" />}
        <div className='booking-icon-text'>
          Requests
        </div>
      </div>

      <div
        className={`booking-icon ${navbarActive === 'myBookings' ? 'active' : ''}`}
        onClick={handleClickBookings}
      >
        {navbarActive === 'myBookings' ? <img src={coloredBookkings} alt="" /> : <img src={icon2} alt="" />}
        <div className='booking-icon-text'>
          My Bookings
        </div>
      </div>
    </div>
  );
}
